/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Translate_De_EnInputs */



/**
* | output |
* | --- |
* | "Translate between German and English" |
*
* @param {Onboarding_Usage_Translate_De_EnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_translate_de_en = /** @type {((inputs?: Onboarding_Usage_Translate_De_EnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Translate_De_EnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zwischen Deutsch und Englisch übersetzen")
	return /** @type {LocalizedString} */ ("Translate between German and English")
});